import axios from "axios";

const manager = {
    submitForm: async (body, config) => {
        return await axios.post(`/api/form`, body, config)
    }
};

export default manager;